module.exports = __webpack_public_path__ + "img/pub_of.ecc918ca.png";